<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner m-0">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img
            class="img-fluid"
            :src="appLogoImage"
            alt="logo"
          />
        </b-link>

        <b-card-title
          title-tag="h2"
          class="font-weight-bold mb-1"
        >
          Forgot your password?
        </b-card-title>

        <b-card-text class="mb-2">
          Enter your email address and we will send you a link to reset your password.
        </b-card-text>

        <b-form
          class="auth-recovery-form mt-2"
          @submit.prevent="submit"
        >
          <b-form-group
            label="Email"
            label-for="recovery-email"
          >
            <b-form-input
              id="recovery-email"
              v-model="form.email"
              name="recovery-email"
              type="email"
              placeholder="john@example.com"
              autocomplete="email"
              autofocus
              :state="emailState"
            />
            <small
              v-if="errorMessage"
              class="text-danger d-block mt-25"
            >{{ errorMessage }}</small>
          </b-form-group>

          <b-button
            type="submit"
            variant="primary"
            block
            :disabled="isLoading"
          >
            <b-spinner
              v-if="isLoading"
              label="Spinning"
              small
            />
            <span v-else>Email me a recovery link</span>
          </b-button>

          <p class="mt-3 mb-0">
            <b-link :to="{ name: 'login' }">
              Back to sign-in
            </b-link>
          </p>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BLink, BFormGroup, BFormInput, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner, BCard,
} from 'bootstrap-vue'
import { toastSuccess, toastFailure } from '@/libs/toastification'
import { mapActions } from 'vuex'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BFormGroup,
    BFormInput,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    BCard,
  },
  data() {
    const { appLogoImage } = $themeConfig.app
    return {
      form: {
        email: '',
      },
      errorMessage: '',
      isLoading: false,
      appLogoImage,
    }
  },
  computed: {
    emailState() {
      if (!this.errorMessage) {
        return null
      }
      return false
    },
  },
  methods: {
    ...mapActions({
      recovery: 'auth/recovery',
    }),
    async submit() {
      this.errorMessage = ''
      const email = String(this.form.email || '').trim()

      if (!email) {
        this.errorMessage = 'Please enter your email address.'
        return
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.errorMessage = 'Please enter a valid email address.'
        return
      }

      this.isLoading = true
      try {
        await this.recovery({ email })
        toastSuccess('If that email exists, a recovery link has been sent.')
        this.$router.replace({ name: 'login' })
      } catch (error) {
        const status = error?.response?.status
        const message = error?.response?.data?.message
          || error?.response?.data?.errors?.email?.[0]
          || 'Could not send the recovery link. Please try again.'

        if (status === 429 || /throttle|wait/i.test(String(message))) {
          this.errorMessage = 'Please wait a minute before requesting another link.'
        } else if (status === 422) {
          this.errorMessage = message
        } else {
          toastFailure(message)
        }
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
